export default [
  {
    id: 'title-1',
    description: 'live',
    seen: false,
    domID: null,
    classes: [{ 'onboarding-bottom': true }],
  },
  {
    id: 'title-2',
    description: 'description-2',
    seen: false,
    domID: null,
    classes: [{ 'onboarding-bottom': true }],
  },
];



// WEBPACK FOOTER //
// ./src/app/features/onboarding/createLiveDiscussionSteps.js